import { TW_FormulaErrorCell } from "@utils/twClasses";
import { useTranslation } from "react-i18next";

/**
 * Content of a cell whose formula could not be computed for its line, the same for every field type.
 * Focus and keyboard navigation stay handled by the GridCell wrapper.
 */
export function FormulaErrorCell() {
    const { t } = useTranslation();
    return (
        <div className={TW_FormulaErrorCell}>
            {t("field.error.value")}
        </div>
    );
}
